<template>
  <div class="venues section">
    <h2>{{ $t('searchFull.salas') }}</h2>
    <div class="separator" />
    <slider :type="'artist'"
            :elements="venuesEvent.venues" />
  </div>
</template>
<script>
import Slider from '@/components/slider/Slider.vue'
export default {
  components: {
    Slider
  },
  props: {
    venuesEvent: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
